export default "__VITE_ASSET__CJGKfaal__"